export interface allResponse<T> {
  data: T;
  result: ResultAPI;
}

interface ResultAPI {
  status: number;
  http_code: HttpCodes;
  info: string;
  errors: any;
}
  type HttpCodes = 200 | 201 | 202 | 204 | 400 | 401 | 403 | 404 | 500 | 503;

export interface CommercialOfferResult {
  commercial_offers: CommercialOfferType[];
}

export interface LoanSimulationPost {
  flows?: string[];
  amount: number;
  singnature_date?: string;
  down_payment?: number;
  is_preferred?: boolean;
}

export enum PaymentMethods {
  CREDIT_CARD = 'CREDIT_CARD',
  BANK_ACCOUNT = 'BANK_ACCOUNT',
}
export interface CommercialOfferType {
  commercial_offer_id: string;
  commercial_offer_name: string;
  financial_offers: LoanSimulation[];
  first_due_date: string;
  flow: string;
  is_preferred: boolean;
  payment_method: PaymentMethods;
}

export interface LoanSimulation {
  commercial_offer_id?: string;
  commercial_offer_name?: string;
  flow?: string;
  first_due_date?: string;
  expenses: number;
  expenses_fix_amount: number;
  expenses_percentage: number;
  expenses_type: string;
  financed_amount: number;
  first_fee: number;
  opening_fee: number;
  opening_fee_fix_amount: number;
  opening_fee_percentage: number;
  opening_fee_type: string;
  product_type: string;
  regular_fee: number;
  tae: number;
  term: number;
  tin: number;
  total_cost: number;
  is_preferred?: boolean;
}
